import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_RELATED_PERSON } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  UpsertRelatedPeopleDetailsPayload,
  UpsertRelatedPeopleDetailsResult,
} from '../types/updateRelatedPeopleDetails.types';

export const updateRelatedPerson = (builder: BuilderType) =>
  builder.mutation<UpsertRelatedPeopleDetailsResult, UpsertRelatedPeopleDetailsPayload>({
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_RELATED_PERSON,
    }),
    transformResponse: (response: GenericApiResponse<UpsertRelatedPeopleDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
